import { render, staticRenderFns } from "./ProductSlotRow.vue?vue&type=template&id=682d2761&scoped=true"
import script from "./ProductSlotRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSlotRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductSlotRow.vue?vue&type=style&index=0&id=682d2761&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682d2761",
  null
  
)

export default component.exports